/* eslint-disable babel/new-cap */
import React, { PropTypes } from "react"
import moment from 'moment'
import styles from "./ClientProfileData.scss"
import sharedProps from "./clientProfileDataPropTypes"
import i18n from "../../../lib/i18n"

const i18profile = i18n("profile")

const childMultiLine = (data) => {
	const field = Object.keys(data)[0]

	return (
		<a className={(data.default == 'true') ? styles.emailDefault : ''}>{data[field]}</a> // eslint-disable-line eqeqeq
	)
}

const MultiLine = (data) => (
	data && data.map((line, i) => (
		<p key={i}>{childMultiLine(line)}</p>
	))
)

const licenceDates = (data) => (
	data && data.map((line, i) => (
		<p key={i}>{line.licenceCategory} ({moment(line.licenceDate).format('DD-MM-YYYY')})</p>
	))
)

const accountNumbers = (data) => (
	data && data.map((line, i) => (
		<p key={i}>{line.IBAN} <br/> (BIC {line.BIC})</p>
	))
)

const mainAddress = (data) => (
	data && (
		<div>
			<p>{data.street} {data.number}/{data.extension}</p>
			<p>{data.postalCode} {data.locality}</p>
			<p>{data.country}</p>
		</div>
	)
)

const Contacts = (contacts) => {
	if (!contacts) {
		return null
	}

	return contacts.map((c, index) => (
		<p key={index}>
			{`${c.contactName} ${c.contactFirstName}: ${c.contactType}, ${c.contactgender}, ${moment(c.contactdateOfBirth).format('DD-MM-YYYY')} (${c.contactNumber})`}
		</p>
	))
}

export const ClientProfileData = ({ main, data, className }) => {
	const col = [
		{label: i18profile('clientNumber'), value: main.clientNumber || '--'},
		{label: i18profile('name'), value: main.name},
		{label: i18profile('email'), value: MultiLine(data.emails)},
		{label: i18profile('phoneNumbers'), value: MultiLine(data.phoneNumbers)},
		{label: i18profile('dateOfBirth'), value: moment(main.dateOfBirth).format('DD-MM-YYYY')},
		{label: i18profile('gender'), value: data.gender},
		{label: i18profile('language'), value: data.language},
		{label: i18profile('licenceDate'), value: licenceDates(data.licences)},
		{label: i18profile('IBAN'), value: accountNumbers(data.accountNumbers)},
		{label: i18profile('mainAddress'), value: mainAddress(main.mainAddress)},
		{label: i18profile('contacts'), value: Contacts(data.contacts)},
	]

    return (
        <div className={className}>
            {col.map((row, i) => (
                <div key={i} className={styles.dataElement}>
                    <div className={styles.dataLabel}>{row.label}{row.label[row.label.length - 1] !== ':' && ':'}</div>
                    <div className={styles.dataValue}>{row.value}</div>
                </div>
            ))}
        </div>
    )
}
ClientProfileData.propTypes = {
    main: sharedProps.main,
    data: sharedProps.detail,
    className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./components/easinsure/client-profile/ClientProfileData.jsx